module.exports = __webpack_public_path__ + "img/DE00336.3d6b4de9.png";